import { useSelector } from "react-redux";
import style from "./Modal-style.module.css";
import { useDispatch } from "react-redux";
import {
  ss_toggle,
  response,
  record_type,
  callBackMethod,
} from "../../stores/slices/smartyStreetSlice";
const SmartStreetModal = () => {
  const dispatch = useDispatch();
  const smartyStreetDetails = useSelector((state) => state.smartyStreetSlice);
  let smartyStreetData = smartyStreetDetails?.smartyStreetData?.responseDetails;
  const ss_toggleFun = () => {
    dispatch(ss_toggle(false));
  };
  const handleModal = (type) => {
    ss_toggleFun();
    if (type == "Secondary") {
      dispatch(response(smartyStreetData?.suggestedAddress));
      if (smartyStreetData?.has_i) {
        smartyStreetData?.callback(
          smartyStreetData?.suggestedAddress,
          smartyStreetData?.i
        );
      } else if (smartyStreetData?.name) {
        smartyStreetData?.callback(
          smartyStreetData?.suggestedAddress,
          smartyStreetData?.name
        );
      } else {
        smartyStreetData?.callback(smartyStreetData?.suggestedAddress);
      }
    } else {
      dispatch(record_type(""));
      dispatch(response(smartyStreetData?.providedAddress));
      if (smartyStreetData?.has_i) {
        smartyStreetData?.callback(
          smartyStreetData?.providedAddress,
          smartyStreetData?.i
        );
      } else if (smartyStreetData?.name) {
        smartyStreetData?.callback(
          smartyStreetData?.providedAddress,
          smartyStreetData?.name
        );
      } else {
        smartyStreetData?.callback(smartyStreetData?.providedAddress);
      }
    }
  };
  return (
    <>
<div className={style.portal_backdrop} />
      <div className={style.popup}>
        <div className={style.popup_content}>
          {smartyStreetData?.partial ? (
            <>
              <p className=" text-center">{smartyStreetData?.ss_msg}</p>
              <div className={`row text-center ${style.smrt_container} p-5`}>
                <div
                  className={`col-md-6 pt-5 border mt-3 pb-3 ${style.smrt_content} mr-1`}
                >
                  <h3>Address-Provided</h3>
                  <p className="pt-5">
                    {smartyStreetData?.providedAddress?.street},{" "}
                    {smartyStreetData?.providedAddress?.street2}
                  </p>
                  <p>
                    {smartyStreetData?.providedAddress?.city},{" "}
                    {smartyStreetData?.providedAddress?.state}
                  </p>
                  <p>{smartyStreetData?.providedAddress?.zipcode}</p>
                  <div className="pt-3">
                    <button
                      color="primary"
                      className={`btn ${style.smt_button}`}
                      onClick={() => {
                        handleModal("Primary");
                      }}
                    >
                      Keep Unverified Address
                    </button>
                  </div>
                </div>
                <div
                  className={`col-md-6 pt-5 pb-3 border mt-3 ml-1 ${style.smrt_content}`}
                >
                  <h3>Address-suggested</h3>
                  <p className="pt-5">
                    {smartyStreetData?.suggestedAddress?.street},{" "}
                    {smartyStreetData?.suggestedAddress?.street2}
                  </p>
                  <p>
                    {smartyStreetData?.suggestedAddress?.city},{" "}
                    {smartyStreetData?.suggestedAddress?.state}
                  </p>
                  <p>{smartyStreetData?.suggestedAddress?.zipcode}</p>
                  <div className="pt-3">
                    <button
                      color="primary"
                      className={`btn ${style.smt_button}`}
                      onClick={() => {
                        handleModal("Secondary");
                      }}
                    >
                      Use Suggested Address
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className=" text-center">
                <p className=" text-center">{smartyStreetData?.ss_msg}</p>
                <h3>Address-Provided</h3>
                <p className="pt-5">
                  {smartyStreetData?.providedAddress?.street},{" "}
                  {smartyStreetData?.providedAddress?.street2}
                </p>
                <p>
                  {smartyStreetData?.providedAddress?.city},{" "}
                  {smartyStreetData?.providedAddress?.state}
                </p>
                <p>{smartyStreetData?.providedAddress?.zipcode}</p>
                <div className="pt-3">
                  <button
                    color="primary"
                    className={`btn ${style.smt_button}`}
                    onClick={() => {
                      handleModal("Primary");
                    }}
                  >
                    Keep Unverified Address
                  </button>
                </div>
              </div>
            </>
          )}

          {/* <button onClick={popupClose}>Close</button> */}
        </div>
      </div>
    </>
  );
};

export default SmartStreetModal;
